import React, { useState, useContext, useEffect} from 'react'
import DOMPurify from 'dompurify';
import Collapse from "react-bootstrap/Collapse";
import {UserContext, ButtonContext } from "../../../Content";
import { CollapseContext } from '../../../ChapterContent';
import Button from "react-bootstrap/Button"
import { Modal } from 'react-bootstrap';
import getYear from '../../../../../utils/getYear';


const Summary = ({ figureData, size }) => {
    const {collapseToggle} = useContext(CollapseContext);
    const [open, setOpen] = useState(collapseToggle);
    const { displayMethods, setdisplayMethods } = useContext(UserContext);
    const [showModal, setShowModal] = useState(false);
    const { activeId, setActiveId } = useContext(ButtonContext);

	const isActive = activeId === figureData.figureNumber;
    const handleClick = (id) => {
        let set_display = displayMethods.title !== figureData.figureNumber ? true : !displayMethods.display;
        setdisplayMethods({display: set_display, title: figureData.figureNumber, text: figureData.detailedMethods});
        setActiveId((prevActiveId) => (prevActiveId === id ? null : id));
      };

    const handleCollapse = () => {
        setOpen(!open);
    };

    const handleModal = (id) => {
        setShowModal(!showModal);
        setActiveId((prevActiveId) => (prevActiveId === id ? null : id));
    }

    const hideModal = () => {
        setShowModal(false);
        setActiveId(null);
    };
     
    useEffect(() => {
        setOpen(collapseToggle);
    }, [collapseToggle]);
        
    return (size !== 'micro' && size !== 'mini') ?
        <>
         {getYear() >= 2025 ? 
            <>       
                <Modal show={showModal} onHide={hideModal} className="informational">
                    <Modal.Header closeButton>
                    <h1>{figureData.figureNumber}</h1>
                    </Modal.Header>
                    <Modal.Body dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(figureData.detailedMethods, { ADD_ATTR: ['target'] }) }}></Modal.Body>
                </Modal>
                <div>
                    <div className="summary-display">
                        <span className="summary-label">Key point</span>
                        <section className="summary-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(figureData.shortSummary, { ADD_ATTR: ['target'] }) }}>
                        </section>
                        <span className="summary-label">Additional context</span>
                        <section className="summary-text print-summary" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(figureData.summary, { ADD_ATTR: ['target'] }) }}>
                        </section>
                        <Button onClick={() => handleClick(figureData.figureNumber)} className="detailed-methods methods-desktop">{isActive ? "Hide Methods" : "Show Methods"}</Button>
                        <Button onClick={() => handleModal(figureData.figureNumber)} className="detailed-methods methods-mobile">{isActive ? "Hide Methods" : "Show Methods"}</Button>
                    </div>
                    <span 
                        onClick={handleCollapse}
                        aria-expanded={open}
                        className="collapse-overview"
                    >
                    <span className="collapse-link">
                        Read more...
                    </span>
                    </span>
                    <Collapse in={open} className="collapse-text">
                        <section dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(figureData.summary, { ADD_ATTR: ['target'] }) }}>
                        </section>
                    </Collapse>
                </div>
            </> :
            <>
                <section dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(figureData.summary, { ADD_ATTR: ['target'] }) }}>
                </section>
            </>
        }
        </>
        : <></>
}

export default Summary